import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { workspaceAdminApi as n } from "@maat/api-main";
//#region src/workspaces/admin/useAdminWorkspacesQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.list({
		...r,
		page: e
	}),
	key: "workspaces"
});
//#endregion
export { r as useAdminWorkspacesQuery };
